import { UseQueryResult } from '@tanstack/react-query'
import {
  BaseHomeItem,
  ErrorHomeItem,
  HomeItem,
  SummaryHomeItem,
  SummaryItem,
} from 'home/types'
import { makeSuccessQueryResult } from 'shared/queries/utils'

export function makeSuccessHomeItem(
  baseItem: BaseHomeItem,
  summaryItems: SummaryItem[],
  badgeCount?: number
): SummaryHomeItem {
  return {
    ...baseItem,
    summary: { badgeCount, items: summaryItems },
  }
}

export function makeErrorHomeItemQueryResult(
  baseItem: BaseHomeItem,
  query: UseQueryResult<HomeItem>
) {
  const data = { ...baseItem, error: query.error as Error } as ErrorHomeItem
  return makeSuccessQueryResult<HomeItem>(query, data)
}

export function makeErrorHomeItem(
  baseItem: BaseHomeItem,
  error: unknown
): ErrorHomeItem {
  return { ...baseItem, error: error as Error }
}
